import React,{Component} from 'react';
import { Link } from 'react-router-dom';
import SimpleReactValidator from 'simple-react-validator';
import templateId from '../../../libraries/lang-id';
import language from '../../../libraries/label-lang';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Logo from '../../../images/logo.png';
import {history} from '../../../shared/configure-store';
import {toast, ToastContainer} from 'react-toastify';
import Copyright from '../../presentational/copyright';
import _ from 'lodash';
import AuthHelper from '../../../libraries/auth-helper';
import Api from '../../../libraries/api';
import {bindActionCreators} from 'redux';

import {connect} from 'react-redux';
import {RootActions} from '../../../shared/root-action';

require('dotenv').config();

SimpleReactValidator.addLocale('indo', templateId);

class Login extends Component {

    constructor(props) {

        super(props);

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );

        this.state = {
            loading: false,
            showPassword: false,

            errors: [],
            email: '',
            password: '',
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = 'Fresh Factory - Login';
    }

    componentWillReceiveProps() {

        let lang = AuthHelper.getLang();

        this.validator = new SimpleReactValidator(
            {
                locale: lang
            }
        );
    }

    handleChange (e, prop){

        this.setState({

            [prop]: e.target.value

        })

    };

    handleChecked = name => e => {

        this.setState({

            [name]: e.target.checked ? 1 : 0,

        })

    };

    handleClickShowPassword = () => {

        this.setState({

            showPassword:(!this.state.showPassword)

        });
    };

    handleSubmit = e => {
        e.preventDefault();

        if (!this.validator.allValid()) {

            this.setState({
                    errors: this.validator.getErrorMessages()
                }
            );

            return false;

        }

        this.setState({
                errors: {},
                loading: true,
            }
        );

        let params = {

            email: this.state.email,

            password: this.state.password,

        };

        Api.post('/login', params).then(resp => {

            AuthHelper.setLogin(resp.data);

            AuthHelper.setProfile(resp.data);

            let profile = resp.data;

            let user = JSON.parse(JSON.stringify(profile));

            this.props.setProfile(user);

            this.__fetchPending();

        }).catch(err => {

            let errors = [];
            if(err.errors) {
                errors = err.errors;
                _.forEach(errors, function(v,k){
                    v = v[0];
                    if(v === 'The selected email is invalid.') {
                        errors = [];
                        err.message = 'Invalid email and password.'
                    }
                });
            }

            this.setState({
                    errors: errors,
                    loading: false
                }
            );

            this.showMessage(false, err.message);
        });

    };

    __fetchPending = () => {
        Api.get('/wallets/pending/transactions').then(resp => {

            let arr = [];

            _.forEach(resp.data.references, function(item){
                if(item.generatedUrl){
                    arr.push(item);
                }
            });

            AuthHelper.setPayment(arr);

            history.push('/');

        }).catch(err => {

            this.showMessage(false, err.message);

        });
    };

    showMessage = (status, message) => {
        if(status) {
            toast.success(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }else {
            toast.error(message, {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }
    };

    render() {

        let lang = {};
        if(this.props.toggle_set_lang === 'indo') {
            lang = language.id;
        }else {
            lang = language.en;
        }
        const text = lang;

        return (
            <main className='login'>
                <section>
                    <div className='container position-relative'>
                        <div className='row align-items-end m-0 row-login'>
                            <div className='col-md-6 col-lg-7 px-lg-7 text-center text-md-left'>
                                <img src={Logo} alt='logo' className='img-logo' />
                            </div>
                            <div className='col-md-6 col-lg-5 px-lg-5 text-center'>
                                <h1>{text.login_heading}</h1>
                                <p>{text.login_welcome},<br />
                                    {text.login_paragraph}</p>
                                <form name='login' id='login' noValidate>
                                    <div className='form-group'>
                                        <TextField
                                            type='text'
                                            id='email'
                                            name='email'
                                            label={text.label_email}
                                            placeholder={text.label_email}
                                            onChange={(e) => this.handleChange(e, 'email')}
                                            value={this.state.email}
                                            fullWidth
                                        />
                                        {this.validator.message('email', this.state.email, 'required')}
                                        <div className='text-danger'>{this.state.errors.email && this.state.errors.email}</div>
                                    </div>
                                    <div className='form-group'>
                                        <TextField
                                                   type={this.state.showPassword ? 'text' : 'password'}
                                                   id='adornment-password'
                                                   name='password'
                                                   label={text.label_password}
                                                   placeholder={text.label_password}
                                                   onChange={(e) => this.handleChange(e,'password')}
                                                   value={this.state.password}
                                                   className='pass'
                                                   InputProps={{
                                                       endAdornment: (
                                                           <InputAdornment position='end'>
                                                               <IconButton
                                                                   aria-label='Toggle password visibility'
                                                                   onClick={this.handleClickShowPassword}
                                                                   className='pass'

                                                               >
                                                                   {this.state.showPassword ? <i className='fas fa-eye'> </i> :
                                                                       <i className='fas fa-eye-slash'> </i>}
                                                               </IconButton>
                                                           </InputAdornment>
                                                       )
                                                   }}
                                                   fullWidth
                                        />
                                        {this.validator.message('password', this.state.password, 'required')}
                                        <div className='text-danger'>{this.state.errors.password && this.state.errors.password}</div>
                                    </div>
                                    <div className='row align-items-center'>
                                        <div className='col-12 text-right mb-3'>
                                            <Link to='/forgot' className='text-blue'>{text.login_forgot}?</Link>
                                        </div>
                                        <div className='col-6 text-left'>
                                            <Link to='/register' className='text-blue'>{text.login_register}</Link>
                                        </div>
                                        <div className='col-6'>
                                            <Button
                                                variant='contained'
                                                onClick={this.handleSubmit}
                                                color='primary'
                                                disabled={this.state.loading}
                                                className='full'
                                                type='submit'
                                            >
                                                {text.button_login} { this.state.loading && <i className='fa fa-spinner fa-spin'> </i> }
                                            </Button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='col-12 mt-auto footer-float'>
                                <div className='row justify-content-end'>
                                    <div className='col-md-6 col-lg-5'>
                                        <footer>
                                            <p className='text-center d-none d-md-block'>
                                                <Copyright />
                                            </p>
                                        </footer>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <footer>
                    <p className='text-center d-md-none'><Copyright /></p>
                </footer>
                <ToastContainer autoClose={false} />
            </main>
        )

    }
}

const mapStateToProps = (state) => {

    return {

        profile_state: state.profile_state,

        toggle_set_lang: state.toggle_set_lang,

    };

};

const mapDispatchToProps = (dispatch) => {

    return bindActionCreators(RootActions, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Login);